export default {
  heroSection: {
    title: {
      fr: "Pilotez votre parc immobilier\ndepuis une seule interface",
      en: "Manage your entire property portfolio\n from a single interface",
    },
    subtitle: {
      fr: "Comme si vous étiez sur place.",
      en: "As if you were on site.",
    },
  },
};
